module.exports = __webpack_public_path__ + "img/environment.7b39eb63.png";